

exports.__esModule = true;

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _checkout = require('xo-models/src/checkout');

var _fi = require('xo-models/src/fi');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoReviewTopup', {
    tag: 'xo-review-topup',
    template: _template2['default'],
    props: {
        token: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token)
            };
        }
    },

    actions: {
        gotoTopupFunding: function gotoTopupFunding() {
            _uiRouter.$state.go('checkout.review.sidepage.topupFunding');
        },
        gotoTopupAmount: function gotoTopupAmount() {
            _uiRouter.$state.go('checkout.review.sidepage.topupAmount');
        }
    },

    lifecycle: {
        enter: function enter() {
            this.formatCurrency = _squid.formatCurrency;
            this.instrumentIconId = function (name) {
                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
            };
        },
        populate: function populate() {
            this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.selectedTopupFundingSource;
            if (!this.models.walletPreferences.topup.fundingSource) {
                this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.topupFundingSources && this.models.checkoutSession.topupFundingSources[0];
            }

            if (!this.models.walletPreferences.topup.amount) {
                this.models.walletPreferences.topup.amount = this.models.walletPreferences.topup.amount || _squid.$config.topup.topupAmounts[0];
                this.models.walletPreferences.topup.currency = _squid.$config.topup.currency;
            }
        }
    }
});


_squid.$Component;

_squid.$config;

_squid.formatCurrency;

_uiRouter.$state;

_checkout.$CheckoutSessionModel;

_fi.$WalletPreferences;

_fi.$WalletInstrumentNameMapping;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/review-topup/directive.js
// module id = ./components/xo-member-components/src/review-topup/directive.js
// module chunks = 1